import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ListadoPeriodosAcademicos from './components/ListadoPeriodosAcademicos';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allPeriodosAcademicosAction,
  setActivoPeriodosAcademicosAction,
} from './PeriodosAcademicosAction';
import FormPeriodosAcademicos from './components/FormPeriodosAcademicos';

const PeriodosAcademicosView = () => {
  const dispatch = Redux.useDispatch();

  const periodosAcademicosStore = Redux.useSelector(
    (state) => state.periodosAcademicos,
  );

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          refreshIcon
          click={async () => {
            await setActivoPeriodosAcademicosAction(dispatch, null);
            await allPeriodosAcademicosAction(
              dispatch,
              periodosAcademicosStore.params,
            );
          }}
          disabled={
            periodosAcademicosStore.loadingAll ||
            periodosAcademicosStore.all.length === 0
          }
          white
          text={
            periodosAcademicosStore.loadingAll
              ? 'Actualizando...'
              : 'Actualizar'
          }
        />
      </Grid>
      <Grid item md={4}>
        <Paper elevation={4} sx={{ pb: 1 }}>
          <FormPeriodosAcademicos isDelete={isDelete} />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoPeriodosAcademicos
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default PeriodosAcademicosView;
